import {generateExportDataSet} from "@containers/export/containers/buildData/helpers/generateDataSet";

import {
    GenerateExportExcelHeadColumnStylesCb,
    GenerateExportExcelRowStylesCb,
    HeadColumns
} from "@ui/tableCustom/types/table";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {IExportDataSetAdditionalItem} from "@containers/export/containers/buildData/hooks/types/exportParams";

import {generateExcelJS} from "../exportExcelJs/generateExcelJs";
import {IExcelBaseSettings} from "@containers/export/containers/excel/types";

interface IProps<T> {
    fileName?: string,
    onDownload?: () => void,
    generateExportExcelRowStylesCb?: GenerateExportExcelRowStylesCb<T>
    generateExportExcelHeadColumnStylesCb?: GenerateExportExcelHeadColumnStylesCb,

    columnExport: IColumnItem<T>[],
    fullColumns: IColumnItem<T>[],
    headColumns?: HeadColumns<T>,
    exportDataFromAllPage?: boolean,
    data: T[],
    additionalDataSet: IExportDataSetAdditionalItem<T>[],
    rootDataSetPosition?:number,
    ignoredExportColumnKey?: string | null,
    order: keyof T | false,
    direction: string,
    allData?: T[],
    t: (key: string) => string,
    exportFromAllColumns?:boolean,
    baseSettings?: IExcelBaseSettings,
    rootYSteps?:number,
}


export const generateExcelFile = async <T>({
                                               fileName,
                                               onDownload,
                                               generateExportExcelRowStylesCb,
                                               generateExportExcelHeadColumnStylesCb,

                                               columnExport,
                                               fullColumns,
                                               headColumns,
                                               exportDataFromAllPage,
                                               allData,
                                               data,
                                               additionalDataSet,
                                               order,
                                               direction,
                                               t,
                                               ignoredExportColumnKey,
                                               rootDataSetPosition,
                                               exportFromAllColumns,
                                               baseSettings,
                                               rootYSteps,
                                           }: IProps<T>) => {
    const dataSet = generateExportDataSet({
        columnExport,
        fullColumns,
        headColumns,
        exportDataFromAllPage,
        allData,
        data,
        additionalDataSet,
        order,
        direction,
        t,
        ignoredExportColumnKey,
        rootDataSetPosition,
        exportFromAllColumns,
        rootYSteps,
    })

    await generateExcelJS({
        dataSet,
        generateExportExcelRowStylesCb,
        generateExportExcelHeadColumnStylesCb,
        fileName,
        baseSettings,
    })
    if (onDownload) {
        onDownload()
    }
}